/**
 * Object containing all available Ezlogic user permission keys.
 *
 * Each property represents a specific permission, and its value is the string identifier
 * used throughout the application to check and assign access rights.
 *
 * @readonly
 * @enum {string}
 *
 * @property {string} MANAGE_USERS - Permission to manage user accounts and related actions.
 * @property {string} MANAGE_MESHBOTS - Permission to manage MeshBots (automation rules/bots).
 * @property {string} MANAGE_VARIABLES_EXPRESSIONS - Permission to manage variables and expressions.
 * @property {string} MANAGE_LUA_SCRIPTS - Permission to manage Lua scripts.
 * @property {string} MANAGE_CLOUD_SERVICES_INTEGRATIONS - Permission to manage cloud services and integrations.
 * @property {string} MANAGE_VIRTUAL_CONTAINER - Permission to manage virtual containers.
 * @property {string} MANAGE_BACKUPS - Permission to manage controller backups.
 * @property {string} MANAGE_CONTROLLER_SETTINGS - Permission to manage controller settings.
 * @property {string} MANAGE_DEVICE_SETTINGS - Permission to manage device settings.
 * @property {string} MANAGE_PLUGINS - Permission to manage plugins.
 * @property {string} MANAGE_NOTIFICATIONS_TEMPLATES - Permission to manage notification templates.
 *
 * @example
 * const isAllowedManage = usePermission(PERMISSIONS.MANAGE_LUA_SCRIPTS);
 */
export const PERMISSIONS = {
    MANAGE_USERS: 'MANAGE_USERS',
    MANAGE_MESHBOTS: 'MANAGE_MESHBOTS',
    MANAGE_VARIABLES_EXPRESSIONS: 'MANAGE_VARIABLES_EXPRESSIONS',
    MANAGE_LUA_SCRIPTS: 'MANAGE_LUA_SCRIPTS',
    MANAGE_CLOUD_SERVICES_INTEGRATIONS: 'MANAGE_CLOUD_SERVICES_INTEGRATIONS',
    MANAGE_VIRTUAL_CONTAINER: 'MANAGE_VIRTUAL_CONTAINER',
    MANAGE_BACKUPS: 'MANAGE_BACKUPS',
    MANAGE_CONTROLLER_SETTINGS: 'MANAGE_CONTROLLER_SETTINGS',
    MANAGE_DEVICE_SETTINGS: 'MANAGE_DEVICE_SETTINGS',
    MANAGE_PLUGINS: 'MANAGE_PLUGINS',
    MANAGE_NOTIFICATIONS_TEMPLATES: 'MANAGE_NOTIFICATIONS_TEMPLATES',
};
